var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditlinInuseActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_609_238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_609_238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_609_238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.71607 12.3496C8.71607 11.2286 7.80894 10.3215 6.68793 10.3215",
    stroke: "url(#paint0_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7214 12.3496C20.7214 11.2286 21.6286 10.3215 22.7496 10.3215",
    stroke: "url(#paint1_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7214 3.78241C20.7214 4.90342 21.6286 5.81055 22.7496 5.81055",
    stroke: "url(#paint2_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7188 3.75037H22.0207C22.4407 3.75037 22.7812 4.09088 22.7812 4.51092V11.6203C22.7812 12.0404 22.4407 12.3809 22.0207 12.3809H16.8281",
    stroke: "url(#paint3_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 12.3809H7.4168C6.9968 12.3809 6.65625 12.0404 6.65625 11.6203V7.54997",
    stroke: "url(#paint4_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7007 7.00222C13.0835 6.27903 13.8435 5.78628 14.7187 5.78628C15.9788 5.78628 17.0004 6.80783 17.0004 8.06792C17.0004 9.32806 15.9788 10.3496 14.7187 10.3496C13.7523 10.3496 12.9261 9.74872 12.5936 8.90014",
    stroke: "url(#paint5_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 1.21921H11.3909C12.0584 1.21921 12.7072 1.44027 13.2358 1.8479L15.7031 3.75046H10.6059C10.0685 3.75046 9.63281 4.18612 9.63281 4.72354C9.63281 5.07759 9.82514 5.4037 10.1349 5.57502L12.5466 6.9088C13.0466 7.18532 13.2689 7.78626 13.0692 8.32162C12.8751 8.84202 12.3377 9.15023 11.7906 9.05512L10.0973 8.76069C8.52033 8.48648 7.02445 7.86379 5.71875 6.93796H4.59375",
    stroke: "url(#paint6_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 7.96875H0.46875V0.468751H4.59375V7.96875Z",
    stroke: "url(#paint7_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4027 22.9688H10.2194C8.59528 22.9688 7.03767 22.3236 5.88923 21.1751L3.34265 18.6285C2.88679 18.1727 2.88853 17.433 3.34654 16.9793C3.80156 16.5285 4.53539 16.5302 4.98825 16.9832L7.26693 19.2625C8.03062 20.0264 9.06647 20.4556 10.1466 20.4556H12.6788",
    stroke: "url(#paint8_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4462 20.4551H10.3419C9.70103 20.4551 9.18152 19.9356 9.18152 19.2947C9.18152 18.6539 9.70103 18.1343 10.3419 18.1343H13.3015L13.9136 17.4076C14.6754 16.5034 15.7975 15.9815 16.9799 15.9815C17.8257 15.9815 18.6499 16.249 19.3345 16.7458L19.4027 16.7953",
    stroke: "url(#paint9_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5312 23.5312H19.4062V16.0313H23.5312V23.5312Z",
    stroke: "url(#paint10_linear_609_238)",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_609_238",
    x1: 7.702,
    y1: 12.3496,
    x2: 7.702,
    y2: 10.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_609_238",
    x1: 21.7355,
    y1: 12.3496,
    x2: 21.7355,
    y2: 10.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_609_238",
    x1: 21.7355,
    y1: 5.81055,
    x2: 21.7355,
    y2: 3.78241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_609_238",
    x1: 18.75,
    y1: 12.3809,
    x2: 18.75,
    y2: 3.75037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_609_238",
    x1: 9.63281,
    y1: 12.3809,
    x2: 9.63281,
    y2: 7.54997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_609_238",
    x1: 14.797,
    y1: 10.3496,
    x2: 14.797,
    y2: 5.78628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_609_238",
    x1: 10.1484,
    y1: 9.07227,
    x2: 10.1484,
    y2: 1.21921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_609_238",
    x1: 2.53125,
    y1: 7.96875,
    x2: 2.53125,
    y2: 0.46875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_609_238",
    x1: 11.2023,
    y1: 22.9688,
    x2: 11.2023,
    y2: 16.6423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_609_238",
    x1: 14.2921,
    y1: 20.4551,
    x2: 14.2921,
    y2: 15.9815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_609_238",
    x1: 21.4687,
    y1: 23.5312,
    x2: 21.4687,
    y2: 16.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#D91B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#963460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_609_238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditlinInuseActive);
export default __webpack_public_path__ + "static/media/creditlin-inuse-active.5e9d3a386071b711e76c07c05d3bfa9a.svg";
export { ForwardRef as ReactComponent };